import { createFileRoute } from "@tanstack/react-router";
import Agb from "@/pages/Agb";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/agb")({
  head: () =>
    seoHead({
      title: "Allgemeine Geschäftsbedingungen | Clicks DMP",
      description:
        "Allgemeine Geschäftsbedingungen von Clicks DMP für Fotografie, Videoproduktion und Social-Media-Content: Termine, Nutzungsrechte, Lieferung, Zahlung, Widerrufsrecht.",
      path: "/agb",
    }),
  component: Agb,
});
